import noodleApiClient from '@/tsClient/servers/noodleApi';
import type { CaseDataSchemaResponse } from '@/typings/api-models';

const getCaseDataSchema = async (): Promise<CaseDataSchemaResponse> => {
  const response = await noodleApiClient.get('/cases/schema');
  return response.data as CaseDataSchemaResponse;
};

export default getCaseDataSchema;
